import { userApi } from "./http";
import { resolveBookingCaseTypeLabel } from "../utils/caseType";

function parsePaidAmount(value) {
  const normalized = String(value ?? "").replace(/[,\s]/g, "").replace(/^(?:₹|rs\.?)/i, "").trim();
  const parsed = Number(normalized);
  return Number.isFinite(parsed) ? parsed : null;
}

function mapBooking(item) {
  const normalizedStatus = String(item?.status || "").toLowerCase();
  const status =
    normalizedStatus === "declined"
        ? "rejected"
        : normalizedStatus || "pending";

  const bookingDateTime = item?.date && item?.time
    ? new Date(`${item.date}T${item.time}:00+05:30`).toISOString()
    : (item?.created_at || item?.createdAt || new Date().toISOString());

  // Resolve consultation_fee from direct field or populated lawyer_id sub-document
  const consultationFee =
    parsePaidAmount(item?.consultation_fee) ??
    parsePaidAmount(item?.lawyer_id?.consultation_fee) ??
    parsePaidAmount(item?.fee) ??
    0;

  return {
    id: item?._id || item?.id || item?.bookingId,
    caseId: item?._id || item?.id || item?.bookingId,
    clientName: item?.client_name || item?.user_id || "Client",
    clientEmail: item?.client_email || "",
    clientPhone: item?.client_phone || "",
    caseType: resolveBookingCaseTypeLabel(item),
    customCaseType: item?.customCaseType || item?.custom_case_type || null,
    rawCaseType: item?.case_type || "",
    consultationType: item?.meeting_link ? "Video Call" : "Consultation",
    location: item?.meeting_link || item?.lawyer_id?.city || "Online",
    language: "English",
    urgency: "moderate",
    description: resolveBookingCaseTypeLabel(item),
    status,
    fee: consultationFee,
    consultation_fee: consultationFee,
    createdAt: item?.created_at || item?.createdAt || new Date().toISOString(),
    scheduledAt: bookingDateTime,
    date: item?.date,
    time: item?.time,
    meetingLink: item?.meeting_link || "",
    meetingProvider: item?.meeting_provider || "",
    raw: item,
  };
}


export async function fetchLawyerBookings() {
  const { data } = await userApi.get("/bookings/lawyer");
  return (Array.isArray(data) ? data : []).map(mapBooking);
}

export async function fetchLawyerBookingsByProfile(lawyerProfileId) {
  const { data } = await userApi.get(
    `/bookings?role=lawyer&lawyerId=${encodeURIComponent(String(lawyerProfileId || ""))}`
  );
  return (Array.isArray(data) ? data : []).map(mapBooking);
}

export async function updateLawyerBookingStatus(bookingId, status) {
  const { data } = await userApi.patch(`/bookings/${bookingId}/status`, { status });
  return mapBooking(data?.booking || {});
}

export async function completeLawyerBooking(bookingId) {
  const { data } = await userApi.patch(`/bookings/${bookingId}/complete`);
  return mapBooking(data?.booking || {});
}
